import CTNButton from '@ctn/ui/components/ctn-button';
import CTNPdfViewer from '@ctn/ui/components/ctn-pdf-viewer';
import { type CTNPdfViewerProps } from '@ctn/ui/types/ctn-pdf-viewer';
import classNames from 'classnames';
import { useMemo } from 'react';

import { MIMETYPE_PDF } from '@/constants/file.constants';


type DocViewerProps = Omit<CTNPdfViewerProps, 'base64'> & { readonly mimeType: string };

const classNameComponent = 'c-pnp-doc-viewer';

const DocViewer = ({ mimeType, url = '', fileName = '', fileIcon, loading, className, onDownload }: DocViewerProps) => {
	const classNameDocViewer = useMemo(() => classNames(classNameComponent, className), [className]);
	const downloadFile = (url: string, name: string) => {
		const a = document.createElement('a');
		a.href = url;
		a.download = name;
		a.click();
		window.URL.revokeObjectURL(url);
		a.remove();
	};

	return (
		<>
			{MIMETYPE_PDF === mimeType ? (
				<CTNPdfViewer
					toolbar={false}
					loading={loading}
					url={url}
					fileIcon={fileIcon}
					fileName={fileName}
					className={className}
					view="FitH"
					onDownload={() => {
						if (onDownload) {
							onDownload();
						}

						downloadFile(url, fileName);
					}}
				/>
			) : (
				<div className={`c-pnp-box c-pnp-box--border ${classNameDocViewer}`}>
					<div className={`[ c-pnp-box__body ] ${classNameComponent}__body`}>
						<p><b>{fileName}</b></p>
						<p>Este formato de documento no se puede visualizar.</p>
						<CTNButton
							mode="secondary"
							label="Descargar"
							size="size-40"
							minWidth='140'
							className="u-mt-16"
							disabled={loading ?? !url}
							onClick={() => {
								if (onDownload) {
									onDownload();
								}

								downloadFile(url, fileName);
							}}
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default DocViewer;
